import { Typography } from "@trustpilot/businessapp-patternlibrary";
import { Text, LocaleDate } from "ilenia";

import { StyledTierName, StyledTier, StyledTierInfo } from "../../styled";
import * as Types from "../../types/types";

const TierInfo: React.FC<Types.TierInfo> = ({ tier, autoRenew }) => (
  <StyledTier>
    {tier.name && (
      <>
        <StyledTierName>
          <Typography as="span" variant="body-m">
            <Text id="Sidebar.upgrade.name" />
          </Typography>
          <Typography as="span" variant="heading-xxxs">
            <strong>{tier.name}</strong>
          </Typography>
        </StyledTierName>
        {!autoRenew && (
          <StyledTierInfo>
            <Typography as="span" variant="body-m">
              <Text id="Sidebar.upgrade.date" />
            </Typography>
            <Typography as="span" variant="heading-xxxs">
              <LocaleDate
                date={tier.expireDate}
                format={{
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                }}
              />
            </Typography>
          </StyledTierInfo>
        )}
      </>
    )}
  </StyledTier>
);

export default TierInfo;
